import { atom, createStore } from "jotai";
import type { Tag } from "@/types";

/**
 * Store
 */
function createHomeStore(
  initialTag: Tag,
  initialCounters: {
    byType: Record<string, number>;
  },
) {
  const store = createStore();
  store.set(featuredTagAtom, initialTag);
  store.set(countersAtom, initialCounters);

  return store;
}

/**
 * Tag Atoms
 */

const featuredTagAtom = atom<Tag | null>(null);

/**
 * Observatory Atoms
 */

const featuredObservatoriesAtom = atom((get) => {
  const featuredTag = get(featuredTagAtom);

  if (featuredTag?.observatories) {
    return featuredTag.observatories;
  }

  return [];
});

/**
 * Sites Atoms
 */

const featuredSitesAtom = atom((get) => {
  const featuredTag = get(featuredTagAtom);
  if (featuredTag?.observatories) {
    return featuredTag.observatories.flatMap(
      (observatory) => observatory.sites ?? [],
    );
  }

  return [];
});

/**
 * Misc Atoms
 */
const countersAtom = atom<{ byType: Record<string, number> }>();

const siteCountAtom = atom((get) => {
  const counters = get(countersAtom);
  if (counters) return counters.byType.site;
});

const observatoryCountAtom = atom((get) => {
  const counters = get(countersAtom);
  if (counters) return counters.byType.observatory;
});

const timeserieCountAtom = atom((get) => {
  const counters = get(countersAtom);
  if (counters) return counters.byType.timeserie;
});

const projectCountAtom = atom((get) => {
  const counters = get(countersAtom);
  if (counters) return counters.byType.project;
});

export {
  createHomeStore,
  featuredTagAtom,
  featuredObservatoriesAtom,
  featuredSitesAtom,
  countersAtom,
  siteCountAtom,
  observatoryCountAtom,
  timeserieCountAtom,
  projectCountAtom,
};
